import { Component, OnInit } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { InwardStatus } from 'src/app/Enums/inwardEnum';
import { AuditData } from 'src/app/shared/classes/AuditTrail';
import { ConstantsService } from 'src/app/shared/services/Constants/constants.service';
import { DataContextService } from 'src/app/shared/services/data-context.service';

@Component({
  selector: 'app-decline-popup',
  templateUrl: './decline-popup.component.html',
  styleUrls: ['./decline-popup.component.less']
})
export class DeclinePopupComponent implements OnInit {
  InwardStatus = InwardStatus;
  service_URL: any;
  count : number = 0;
  reason : string = '';
  selectedRequest: any;
  flag: boolean = true;

  private unsubscribe$ = new Subject<void>();

  constructor(
    private modalService: BsModalService,
    private _dataContextService: DataContextService,
    private toast: ToastrService
  ) {
    this.service_URL = ConstantsService;
  }

  ngOnInit(): void {
  }

  Cancel() {
    this.modalService.hide(1);
    $('body').removeClass('modal-open');
  }

  showcount(reason : any){
    this.count = this.reason.length;
    if(this.reason !== '' && this.count > 0){
      this.flag = false;
    }
    else{
      this.flag = true;
    }
  }

  Submit(){
    let params = {
      statusId : InwardStatus.Declined,
      requestId : this.selectedRequest.requestId,
      CancelNotes:'',
      declinedByNotes: this.reason,
      updatedBy: localStorage.getItem('email')
    }

    let auditData = [];

    let statusChangeAudit: AuditData = new AuditData();
    statusChangeAudit.changedAttribute = "Status";
    statusChangeAudit.oldValue = "Check Materials";
    statusChangeAudit.newValue = "Declined"

    auditData.push(statusChangeAudit);

      this._dataContextService.postDatawithValues<any>(this.service_URL.InwardDetails.UpdateStatus,params)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res) => {
        if(res == 1){
          this.toast.success("Request Declined");
        }
        else{
          this.toast.error("Something went wrong");
        }
      },
      (err) => {
        console.log(err);
      },
      () => {
        //Saving Data in Audit Trail
      let auditParams = {
        actionPerformed : "Status Change",
        actionPerformedOn : "Inward",
        changedBy : localStorage.getItem('email'),
        dateChanged : new Date(),
        primaryKey : this.selectedRequest.serialNumber,
        generalInformation : [],
        material : [],
        statusChange: auditData
      };

        this._dataContextService.postDatawithValues<any>(this.service_URL.AuditTrail.savetransactionaudittrail,auditParams)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((res) => {
          // console.log(res);
        },
        (err) => {
          console.log(err);
        },
        () => {
          this.modalService.hide(1);
          window.location.reload();
        })
      })
  }

}
